import {
  UPDATE_LISTING_IMAGE,
  ADD_LISTING_IMAGE,
  SET_LISTING,
  CHANGE_LISTING,
  ADD_LISTING_IMAGE_ERROR,
  UPDATE_LISTING_IMAGE_ERROR,
  INIT_LISTING,
  ADD_LISTING_PORTAL,
} from '../constants/actions'
import { uploadMainImage } from '../modules/portal-remote/portalImageService'

export const initListing = () => ({ type: INIT_LISTING })

export const setListing = listing => ({
  type: SET_LISTING,
  listing,
})

export const changeListing = (path, value) => ({
  type: CHANGE_LISTING,
  path,
  value,
})

export const addListingPortal = portal => ({
  type: ADD_LISTING_PORTAL,
  portal,
})

export const addListingImage = imageFile => async dispatch => {
  try {
    const {
      ref: mainImageId,
      lastChecked: mainImageLastChecked,
    } = await uploadMainImage(imageFile)
    dispatch({ type: ADD_LISTING_IMAGE, mainImageId, mainImageLastChecked })
  } catch ({ message }) {
    dispatch({ type: ADD_LISTING_IMAGE_ERROR, message })
  }
}

export const updateListingImage = (
  imageFile,
  repalceImageID,
  originalImageID,
) => async dispatch => {
  try {
    const {
      ref: mainImageId,
      lastChecked: mainImageLastChecked,
    } = await uploadMainImage(imageFile, repalceImageID, originalImageID)
    dispatch({ type: UPDATE_LISTING_IMAGE, mainImageId, mainImageLastChecked })
  } catch ({ message }) {
    dispatch({ type: UPDATE_LISTING_IMAGE_ERROR, message })
  }
}



// WEBPACK FOOTER //
// ./src/actions/listing.js